import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useRenewAthletePackage(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const renewAthletePackage = (athletePackageId: string): Promise<AxiosResponse<null>> => {
    return client.post(`athlete-packages/${athletePackageId}/renew/`, {});
  };

  return useMutation(renewAthletePackage, {
    onSuccess: () => {
      queryClient.invalidateQueries('athletePackages');
    },
  });
}
